import React from 'react';
import logo from '../../assets/images/club-logo.svg';
import { IClub } from '../../store/player/clubs/store';
import { ISource, IStripeToken } from '../../store/user/store';
import Button from '../Button';

interface IProps {
  club: IClub;
  clubId: number;
  next: (clubId: number, payment?: IStripeToken | ISource) => void;
}

const JoinClubCta = (props: IProps) => {
  const nextHandler = () => {
    props.next(props.clubId);
  };

  return (
    <div className="join-club-cta">
      <img
        className="join-club-cta__club-logo"
        src={props.club.profileImage || logo}
        id="club-logo"
      />
      <h1 className="join-club-cta__title">{props.club.name}</h1>
      <Button
        variant="contained"
        color="primary"
        onClick={nextHandler}
        className="button--shadow join-club-cta__button"
      >
        JOIN CLUB
      </Button>
    </div>
  );
};

export { JoinClubCta };
